(function () {
  var BILL_NOTE = 'Billed and shipped on the 5th of the month. Skip or cancel any time.';
  function init(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var P = JSON.parse(root.querySelector('[data-pp-json]').textContent);
    var money = function (c) { return (window.Tasteio && Tasteio.money) ? Tasteio.money(c) : '₹' + Math.round(c / 100); };
    var $ = function (s) { return root.querySelector(s); }, $$ = function (s) { return [].slice.call(root.querySelectorAll(s)); };
    var plans = {};
    (P.selling_plan_groups || []).forEach(function (g) { (g.selling_plans || []).forEach(function (sp) { plans[sp.id] = { name: sp.name }; }); });
    var vid = +$('[data-vid]').value;
    function variant() { return P.variants.find(function (v) { return v.id === vid; }) || P.variants[0]; }
    function qty() { return Math.max(1, +$('[data-qty]').value || 1); }
    function update() {
      var v = variant();
      var allocs = (v.selling_plan_allocations || []).filter(function (a) { return plans[a.selling_plan_id]; });
      var row = $('[data-subrow]'), sel = $('[data-freq]'), sp = $('[data-sp]'), subR = $('input[name=pp-plan][value=sub]');
      row.hidden = !allocs.length; row.style.display = allocs.length ? '' : 'none';
      if (!allocs.length) { $$('input[name=pp-plan]')[0].checked = true; }
      var keep = sel.value;
      sel.innerHTML = allocs.map(function (a) { return '<option value="' + a.selling_plan_id + '">' + plans[a.selling_plan_id].name + '</option>'; }).join('');
      if (allocs.some(function (a) { return String(a.selling_plan_id) === keep; })) sel.value = keep;
      sel.hidden = allocs.length < 2; sel.style.display = allocs.length < 2 ? 'none' : '';
      var a = allocs.find(function (x) { return String(x.selling_plan_id) === sel.value; }) || allocs[0];
      var subbed = !!a && subR.checked, each = v.price;
      if (a) {
        var pct = Math.round((1 - a.price / v.price) * 100);
        $('[data-save]').textContent = pct > 0 ? pct + '%' : '';
        $('[data-p-sub]').textContent = money(a.price);
        $('[data-subnote]').textContent = (allocs.length > 1 ? 'Choose how often. ' : plans[a.selling_plan_id].name + ' · ' + v.title + '. ') + BILL_NOTE;
        if (subbed) each = a.price;
      }
      sp.disabled = !subbed; sp.value = subbed ? a.selling_plan_id : '';
      $('[data-vid]').value = v.id;
      $('[data-price]').textContent = money(each);
      $('[data-p-one]').textContent = money(v.price);
      $('[data-unit]').textContent = v.title === 'Default Title' ? '' : '· ' + v.title;
      var cmp = $('[data-compare]'), showC = v.compare_at_price && v.compare_at_price > each;
      cmp.hidden = !showC; if (showC) cmp.textContent = money(v.compare_at_price);
      var add = $('[data-add]'); add.disabled = !v.available;
      add.textContent = !v.available ? 'Sold out' : (subbed ? 'Subscribe & save · ' : 'Add to bag · ') + money(each * qty());
      var wa = $('[data-wa]');
      if (wa) wa.href = wa.dataset.base + encodeURIComponent('Hi Tasteio, I would like to order ' + P.title + (v.title !== 'Default Title' ? ' (' + v.title + ')' : '') + ' x ' + qty());
      if (v.featured_media) show(v.featured_media.id);
      if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
    }
    function show(id) {
      var hit = $$('[data-media]').some(function (m) { return String(m.dataset.media) === String(id); }); if (!hit) return;
      $$('[data-media]').forEach(function (m) { m.classList.toggle('is-on', String(m.dataset.media) === String(id)); });
      $$('[data-thumb]').forEach(function (t) { t.setAttribute('aria-current', String(t.dataset.thumb) === String(id)); });
    }
    root.addEventListener('change', function (e) { if (e.target.name === 'pp-variant') vid = +e.target.value; update(); });
    root.addEventListener('input', function (e) { if (e.target.matches('[data-qty]')) update(); });
    root.addEventListener('click', function (e) {
      var s = e.target.closest('[data-step]');
      if (s) { e.preventDefault(); var q = $('[data-qty]'); q.value = Math.max(1, (+q.value || 1) + (+s.dataset.step)); update(); return; }
      var th = e.target.closest('[data-thumb]'); if (th) { show(th.dataset.thumb); return; }
      var b = e.target.closest('[data-back]');
      if (b && document.referrer.indexOf(location.host) > -1 && history.length > 1) { e.preventDefault(); history.back(); }
    });
    $('[data-freq]').addEventListener('click', function () { var r = $('input[name=pp-plan][value=sub]'); if (!r.checked) { r.checked = true; update(); } });
    update();
  }
  function boot() { [].forEach.call(document.querySelectorAll('[data-pp]'), init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();